var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowsArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 21,
    viewBox: "0 0 60 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.235 8.446h50.881l-5.308-5.308c-.718-.717-.718-1.882 0-2.6.718-.717 1.882-.717 2.6 0l8.46 8.46c.346.345.54.813.54 1.3 0 .488-.194.956-.54 1.3l-8.46 8.46c-.718.718-1.882.718-2.6 0-.718-.717-.718-1.882 0-2.6l5.308-5.327H2.236c-1.017-.003-1.84-.826-1.844-1.843.004-1.016.827-1.838 1.843-1.842z",
    transform: "translate(-832 -248) translate(682 197) translate(29 21) translate(121 30)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsArrow);
export default __webpack_public_path__ + "static/media/arrows-arrow.cbd87a977c46ead6017db7eeb815f40f.svg";
export { ForwardRef as ReactComponent };